module.exports = {
  // 应用id
  appId: '90001',

  title: '登录',

  hostDomain: 'geekyum'
}
